import { ref, h, watch } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-01842c6d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "appListPopover-content"
};
const _hoisted_3 = {
  class: "appListPopover-content-title"
};
const _hoisted_4 = {
  class: "inf-label"
};
const _hoisted_5 = {
  class: "inf-value"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "复制", -1));
const _hoisted_7 = {
  class: "appListPopover-content"
};
const _hoisted_8 = {
  class: "appListPopover-content-title"
};
const _hoisted_9 = {
  class: "inf-label"
};
const _hoisted_10 = {
  class: "inf-value"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "复制", -1));
import { Modal } from 'ant-design-vue';
import { awaitWrap, filterOption, OK, reportEvent, detailFields, searchFields, getAppListInformation, copy } from '@/common';
import { message } from 'ant-design-vue';
import { addWhiteList, getAppListByPayChnl, queryAppListByAccountId, queryEntityAccount, queryModalPayChnl, queryWhiteAppList, updateWhiteList } from '@/api/whitelist';
// import SearchCheckSelect from '@/views/revenueKanbanManage/components/SearchCheckSelect.vue'
import { ProductSelect } from '@dbt/product-select';
import '@dbt/product-select/dist/style.css';
export default /*#__PURE__*/_defineComponent({
  __name: 'WhiteAddModal',
  props: {
    modalVisible: {
      type: Boolean
    },
    editItem: null
  },
  emits: ['update:modalVisible', 'refresh', 'clearEditItem'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const marketList = [{
      label: '账号',
      value: '1'
    }, {
      label: 'DBTID',
      value: '2'
    }, {
      label: '设备ID',
      value: '3'
    }];
    const visible = ref(false);
    const accountForm = ref();
    const formValue = ref({
      market: '1',
      account: null,
      dbtIdList: [],
      deviceId: '',
      payChnl: null,
      dbtId: null
    });
    const dbtIdParams = ref('');
    const rules = ref({
      market: [{
        required: true,
        message: '请选择市场',
        trigger: 'change'
      }],
      account: [{
        required: true,
        message: '请选择账号',
        trigger: 'change'
      }],
      dbtIdList: [{
        required: true,
        message: '请选择产品',
        trigger: 'change'
      }],
      dbtId: [{
        required: true,
        message: '请选择产品',
        trigger: 'change'
      }],
      deviceId: [{
        required: true,
        message: '请输入设备ID',
        trigger: 'blur'
      }],
      payChnl: [{
        required: true,
        message: '请选择支付渠道',
        trigger: 'change'
      }]
    });
    const accountList = ref();
    const appNameList = ref([]);
    // const appNameRef = ref<any>(null)
    const channelList = ref([]);
    const productSelectMultiRef = ref(null);
    const productSelectRef = ref(null);
    const closeModal = () => {
      var _accountForm$value;
      (_accountForm$value = accountForm.value) === null || _accountForm$value === void 0 || _accountForm$value.clearValidate();
      dbtIdParams.value = '';
      formValue.value = {
        market: '1',
        account: null,
        dbtIdList: [],
        deviceId: '',
        payChnl: null,
        dbtId: null
      };
      //   appNameRef.value?.init()
      emit('clearEditItem', {});
      emit('update:modalVisible', false);
    }; // 关闭弹窗
    const handleOk = () => {
      var _accountForm$value2;
      (_accountForm$value2 = accountForm.value) === null || _accountForm$value2 === void 0 || _accountForm$value2.validate().then(async () => {
        var _props$editItem;
        if ((_props$editItem = props.editItem) !== null && _props$editItem !== void 0 && _props$editItem.id) {
          handleSave();
        } else {
          if (formValue.value.market == '3') {
            if (!formValue.value.dbtId) {
              return message.error('请选择产品');
            }
            handleSave();
          } else {
            if (!formValue.value.dbtIdList.length) return message.error('请选择产品');
            Modal.confirm({
              title: '二次确认,确定保存吗？',
              centered: true,
              content: () => {
                var _formValue$value$dbtI;
                return h('div', (_formValue$value$dbtI = formValue.value.dbtIdList) === null || _formValue$value$dbtI === void 0 ? void 0 : _formValue$value$dbtI.map(item => {
                  let curItem = appNameList.value.find(ls => ls.dbtId === item);
                  return h('div', {}, (curItem === null || curItem === void 0 ? void 0 : curItem.label) + ':' + (curItem === null || curItem === void 0 ? void 0 : curItem.dbtId));
                }));
              },
              onOk: () => {
                handleSave();
              }
            });
          }
        }
      }).catch(error => {});
    }; // 确定
    const handleSave = async () => {
      var _props$editItem2, _props$editItem3;
      let params = {
        filterType: formValue.value.market === '3' ? 'deviceId' : 'payChnl'
      };
      if ((_props$editItem2 = props.editItem) !== null && _props$editItem2 !== void 0 && _props$editItem2.id) {
        var _formValue$value$devi;
        params = {
          ...params,
          id: props.editItem.id,
          deviceId: (_formValue$value$devi = formValue.value.deviceId) === null || _formValue$value$devi === void 0 || (_formValue$value$devi = _formValue$value$devi.replace(/；/g, ';')) === null || _formValue$value$devi === void 0 || (_formValue$value$devi = _formValue$value$devi.replace(/\s+/g, '')) === null || _formValue$value$devi === void 0 || (_formValue$value$devi = _formValue$value$devi.split(';')) === null || _formValue$value$devi === void 0 ? void 0 : _formValue$value$devi.filter(item => item)
        };
      } else {
        var _formValue$value$devi2;
        params = {
          ...params,
          dbtIdList: formValue.value.dbtIdList.map(item => item),
          deviceId: (_formValue$value$devi2 = formValue.value.deviceId) === null || _formValue$value$devi2 === void 0 || (_formValue$value$devi2 = _formValue$value$devi2.replace(/；/g, ';')) === null || _formValue$value$devi2 === void 0 || (_formValue$value$devi2 = _formValue$value$devi2.replace(/\s+/g, '')) === null || _formValue$value$devi2 === void 0 || (_formValue$value$devi2 = _formValue$value$devi2.split(';')) === null || _formValue$value$devi2 === void 0 ? void 0 : _formValue$value$devi2.filter(item => item),
          payChnl: formValue.value.payChnl
        };
        if (formValue.value.market === '3') {
          params.dbtIdList = [formValue.value.dbtId];
        }
      }
      /*if (Object.keys(params).length) {
                    return console.log(
                      '%c[WhiteAddModal.vue] - 125',
                      'padding:2px;border-radius:4px;background:lightcoral;color:#fff',
                      params,
                    )
                  }*/
      let fn = (_props$editItem3 = props.editItem) !== null && _props$editItem3 !== void 0 && _props$editItem3.id ? updateWhiteList : addWhiteList;
      const [err, data] = await awaitWrap(fn(params));
      if (data && data.code === OK) {
        message.success('保存成功');
        emit('refresh');
        closeModal();
        reportEvent({
          eventName: 'element_use',
          properties: {
            ui_name: '验单白名单',
            element_name: '保存'
          }
        });
      }
      if (err) message.error('新增失败');
    }; // 保存
    const getAccountList = async () => {
      const [err, data] = await awaitWrap(queryEntityAccount());
      if (data && data.code === OK) {
        var _data$data;
        accountList.value = (_data$data = data.data) === null || _data$data === void 0 || (_data$data = _data$data.accountInfoList) === null || _data$data === void 0 ? void 0 : _data$data.map(item => {
          return {
            label: item.accountName,
            value: item.accountId
          };
        });
      }
      if (err) {}
    }; // 获取账号列表
    const getAppListByAccountId = async () => {
      //   appNameRef.value?.init()
      formValue.value.dbtIdList = [];
      const [err, data] = await awaitWrap(queryAppListByAccountId({
        accountId: formValue.value.account
      }));
      if (data && data.code === OK) {
        var _data$data2, _productSelectMultiRe, _productSelectRef$val, _data$data3;
        appNameList.value = (_data$data2 = data.data) === null || _data$data2 === void 0 || (_data$data2 = _data$data2.list) === null || _data$data2 === void 0 ? void 0 : _data$data2.map((item, index) => {
          var _item$extData;
          return {
            label: item.appName,
            value: item.dbtId + item.payChnl + index,
            dbtId: item.dbtId,
            ...item.extData,
            extData: item.extData,
            filePath: ((_item$extData = item.extData) === null || _item$extData === void 0 ? void 0 : _item$extData.filePath) || '-'
          };
        });
        (_productSelectMultiRe = productSelectMultiRef.value) === null || _productSelectMultiRe === void 0 || _productSelectMultiRe.initializeOptions(appNameList.value);
        (_productSelectRef$val = productSelectRef.value) === null || _productSelectRef$val === void 0 || _productSelectRef$val.initializeOptions(appNameList.value);
        formValue.value.payChnl = (_data$data3 = data.data) === null || _data$data3 === void 0 ? void 0 : _data$data3.payChnl;
        if (formValue.value.market !== 3) {
          formValue.value.dbtIdList = appNameList.value.map(item => item.dbtId);
        }
        // appNameRef.value.showPop = true
        // nextTick(() => {
        //   appNameRef.value?.onCheckAllChange({ target: { checked: true } })
        //   appNameRef.value.showPop = false
        // })
      }
      if (err) {}
    }; // 根据账号获取产品列表
    const getAppListByChnl = async () => {
      const [err, data] = await awaitWrap(getAppListByPayChnl({
        payChnl: formValue.value.payChnl
      }));
      if (data && data.code === OK) {
        var _data$data4, _productSelectMultiRe2;
        appNameList.value = (_data$data4 = data.data) === null || _data$data4 === void 0 || (_data$data4 = _data$data4.list) === null || _data$data4 === void 0 ? void 0 : _data$data4.map((item, index) => {
          return {
            label: item.appName,
            value: item.dbtId + item.payChnl + index,
            dbtId: item.dbtId,
            ...item.extData,
            extData: item.extData
          };
        });
        (_productSelectMultiRe2 = productSelectMultiRef.value) === null || _productSelectMultiRe2 === void 0 || _productSelectMultiRe2.initializeOptions(appNameList.value);
        // appNameRef.value?.init()
        formValue.value.dbtIdList = [];
      }
      if (err) {}
    }; // 根据渠道获取产品列表
    const getWhiteAppList = async () => {
      const [err, data] = await awaitWrap(queryWhiteAppList());
      if (data && data.code === OK) {
        var _data$data5, _productSelectRef$val2;
        appNameList.value = (_data$data5 = data.data) === null || _data$data5 === void 0 || (_data$data5 = _data$data5.list) === null || _data$data5 === void 0 ? void 0 : _data$data5.map((item, index) => {
          return {
            label: item.appName,
            value: item.dbtId + item.payChnl + index,
            dbtId: item.dbtId,
            ...item.extData,
            extData: item.extData
          };
        });
        (_productSelectRef$val2 = productSelectRef.value) === null || _productSelectRef$val2 === void 0 || _productSelectRef$val2.initializeOptions(appNameList.value);
      }
      if (err) {}
    }; // 获取所有产品列表
    const getChnl = async () => {
      // 验单逻辑渠道保留值 2025-08-01调整
      let mapList = ['google', 'apple', 'amazon', 'huawei_foreign', 'huawei', 'wxpay', 'alipay'];
      const [err, data] = await awaitWrap(queryModalPayChnl());
      if (data && data.code === OK) {
        channelList.value = data.data.filter(ls => mapList.includes(ls.payChnl)).map(item => ({
          label: item.payChnlName,
          value: item.payChnl
        }));
      }
      if (err) {}
    }; // 获取支付渠道
    const returnAppName = arr => {
      formValue.value.dbtIdList = arr;
    }; // 产品名称
    const changeType = () => {
      formValue.value.account = null;
      formValue.value.dbtIdList = [];
      formValue.value.deviceId = '';
      formValue.value.payChnl = null;
      formValue.value.dbtId = null;
      dbtIdParams.value = '';
      appNameList.value = [];
      //   appNameRef.value?.init()
      switch (formValue.value.market) {
        case '1':
          getAccountList();
          break;
        case '2':
          getChnl();
          break;
        case '3':
          getChnl();
          getWhiteAppList();
          break;
      }
    }; // 切换市场
    const handleDbtList = () => {
      formValue.value.dbtIdList = appNameList.value.filter(item => item.value === formValue.value.dbtId);
    }; // 选择产品
    watch(() => props.modalVisible, n => {
      visible.value = n;
      if (visible.value) getAccountList();
    }, {
      immediate: true
    });
    watch(() => props.editItem, n => {
      if (n !== null && n !== void 0 && n.id) {
        formValue.value.deviceId = n.deviceIds;
        formValue.value.market = '3';
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      var _props$editItem4;
      const _component_a_radio_group = _resolveComponent("a-radio-group");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_select = _resolveComponent("a-select");
      const _component_SvgIcon = _resolveComponent("SvgIcon");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_textarea = _resolveComponent("a-textarea");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        "mask-closable": false,
        open: visible.value,
        "onUpdate:open": _cache[7] || (_cache[7] = $event => visible.value = $event),
        title: (_props$editItem4 = __props.editItem) !== null && _props$editItem4 !== void 0 && _props$editItem4.id ? '编辑白名单' : '新增白名单',
        width: "540px",
        centered: "",
        "ok-text": "保存",
        onOk: handleOk,
        onCancel: closeModal,
        class: "white-add-modal"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form, {
          name: "accountForm",
          model: formValue.value,
          ref_key: "accountForm",
          ref: accountForm,
          rules: rules.value
        }, {
          default: _withCtx(() => {
            var _props$editItem5, _props$editItem6;
            return [!((_props$editItem5 = __props.editItem) !== null && _props$editItem5 !== void 0 && _props$editItem5.id) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form_item, {
              label: "新增方式",
              name: "market"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_radio_group, {
                value: formValue.value.market,
                "onUpdate:value": _cache[0] || (_cache[0] = $event => formValue.value.market = $event),
                options: marketList,
                onChange: changeType
              }, null, 8, ["value"])]),
              _: 1
            }), formValue.value.market === '1' ? (_openBlock(), _createBlock(_component_a_form_item, {
              key: 0,
              label: "账号",
              name: "account"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_select, {
                onChange: getAppListByAccountId,
                value: formValue.value.account,
                "onUpdate:value": _cache[1] || (_cache[1] = $event => formValue.value.account = $event),
                options: accountList.value,
                placeholder: "请选择",
                "show-search": "",
                "filter-option": _unref(filterOption)
              }, null, 8, ["value", "options", "filter-option"])]),
              _: 1
            })) : _createCommentVNode("", true), formValue.value.market === '2' ? (_openBlock(), _createBlock(_component_a_form_item, {
              key: 1,
              label: "支付渠道",
              name: "payChnl"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_select, {
                onChange: getAppListByChnl,
                value: formValue.value.payChnl,
                "onUpdate:value": _cache[2] || (_cache[2] = $event => formValue.value.payChnl = $event),
                options: channelList.value,
                placeholder: "请选择",
                "show-search": "",
                "filter-option": _unref(filterOption)
              }, null, 8, ["value", "options", "filter-option"])]),
              _: 1
            })) : _createCommentVNode("", true), formValue.value.market !== '3' ? (_openBlock(), _createBlock(_component_a_form_item, {
              key: 2,
              label: "产品名称",
              required: ""
            }, {
              default: _withCtx(() => [_createVNode(_unref(ProductSelect), {
                ref_key: "productSelectMultiRef",
                ref: productSelectMultiRef,
                modelValue: formValue.value.dbtIdList,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formValue.value.dbtIdList = $event),
                multiple: true,
                "show-select-all": true,
                "show-extra": true,
                "search-fields": _unref(searchFields),
                "max-tag-count": 1,
                valueField: "dbtId",
                "show-detail": true,
                layout: "vertical",
                descriptionField: "filePath",
                width: "100%",
                "popup-class-name": "vertical-product-select",
                placeholder: "请选择",
                detailFields: _unref(detailFields),
                "show-bottom-border": ""
              }, {
                detail: _withCtx(({
                  detail
                }) => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_SvgIcon, {
                  iconClass: "informationIcon",
                  class: "informationIcon"
                }), _createTextVNode(" " + _toDisplayString(detail.label), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAppListInformation)(detail === null || detail === void 0 ? void 0 : detail.extData), child => {
                  return _openBlock(), _createElementBlock("div", {
                    key: child.label,
                    class: "inf-line"
                  }, [_createElementVNode("div", _hoisted_4, _toDisplayString(child.label) + "：", 1), _createElementVNode("div", _hoisted_5, _toDisplayString(child.value), 1), _createVNode(_component_a_tooltip, {
                    placement: "top"
                  }, {
                    title: _withCtx(() => [_hoisted_6]),
                    default: _withCtx(() => [_createVNode(_component_SvgIcon, {
                      iconClass: "copy",
                      class: "dbt-copyIcon",
                      onClick: $event => _unref(copy)(child.value)
                    }, null, 8, ["onClick"])]),
                    _: 2
                  }, 1024)]);
                }), 128))])]),
                _: 1
              }, 8, ["modelValue", "search-fields", "detailFields"])]),
              _: 1
            })) : _createCommentVNode("", true), formValue.value.market === '3' ? (_openBlock(), _createBlock(_component_a_form_item, {
              key: 3,
              label: "产品名称",
              name: "dbtId",
              required: ""
            }, {
              default: _withCtx(() => [_createVNode(_unref(ProductSelect), {
                ref_key: "productSelectRef",
                ref: productSelectRef,
                modelValue: formValue.value.dbtId,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formValue.value.dbtId = $event),
                multiple: false,
                "show-extra": true,
                valueField: "dbtId",
                "search-fields": _unref(searchFields),
                "max-tag-count": 1,
                "show-detail": true,
                layout: "vertical",
                descriptionField: "filePath",
                width: "100%",
                "popup-class-name": "vertical-product-select",
                placeholder: "请选择",
                detailFields: _unref(detailFields)
              }, {
                detail: _withCtx(({
                  detail
                }) => [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_SvgIcon, {
                  iconClass: "informationIcon",
                  class: "informationIcon"
                }), _createTextVNode(" " + _toDisplayString(detail.label), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAppListInformation)(detail.extData), child => {
                  return _openBlock(), _createElementBlock("div", {
                    key: child.label,
                    class: "inf-line"
                  }, [_createElementVNode("div", _hoisted_9, _toDisplayString(child.label) + "：", 1), _createElementVNode("div", _hoisted_10, _toDisplayString(child.value), 1), _createVNode(_component_a_tooltip, {
                    placement: "top"
                  }, {
                    title: _withCtx(() => [_hoisted_11]),
                    default: _withCtx(() => [_createVNode(_component_SvgIcon, {
                      iconClass: "copy",
                      class: "dbt-copyIcon",
                      onClick: $event => _unref(copy)(child.value)
                    }, null, 8, ["onClick"])]),
                    _: 2
                  }, 1024)]);
                }), 128))])]),
                _: 1
              }, 8, ["modelValue", "search-fields", "detailFields"])]),
              _: 1
            })) : _createCommentVNode("", true), formValue.value.market === '3' ? (_openBlock(), _createBlock(_component_a_form_item, {
              key: 4,
              label: "支付渠道",
              name: "payChnl"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_select, {
                value: formValue.value.payChnl,
                "onUpdate:value": _cache[5] || (_cache[5] = $event => formValue.value.payChnl = $event),
                options: channelList.value,
                placeholder: "请选择",
                "show-search": "",
                "filter-option": _unref(filterOption)
              }, null, 8, ["value", "options", "filter-option"])]),
              _: 1
            })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), formValue.value.market === '3' || (_props$editItem6 = __props.editItem) !== null && _props$editItem6 !== void 0 && _props$editItem6.id ? (_openBlock(), _createBlock(_component_a_form_item, {
              key: 1,
              label: "设备ID",
              name: "deviceId"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_textarea, {
                value: formValue.value.deviceId,
                "onUpdate:value": _cache[6] || (_cache[6] = $event => formValue.value.deviceId = $event),
                placeholder: "请填写设备ID，多个设备ID请用英文;分隔"
              }, null, 8, ["value"])]),
              _: 1
            })) : _createCommentVNode("", true)];
          }),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["open", "title"]);
    };
  }
});